import React, { Component } from "react";
import PropTypes from "prop-types";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

import ApexRadial from "./ApexRadial";

class MonthlyEarning extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // const { date, data } = this.props;

    return (
      <React.Fragment>
        {" "}
        <Card style={{ height: 240 }}>
          <CardBody>
            <CardTitle className="mb-4 h4">Earning</CardTitle>
            <Row>
              <Col sm="6">
                <p className="text-muted">From selected date range</p>
                <h3>$1145</h3>
                <p className="text-muted">
                  <span className="text-success me-2">
                    {" "}
                    15 % <i className="mdi mdi-arrow-up"></i>{" "}
                  </span>{" "}
                  From previous period
                </p>
                <div className="mt-4">
                  {/* <span to="" className="btn btn-primary btn-sm disabled">
                    View More <i className="mdi mdi-arrow-right ms-1"></i>
                  </span> */}
                </div>
              </Col>
              <Col sm="6">
                <div className="mt-4 mt-sm-0">
                  <ApexRadial data={115} />
                </div>
              </Col>
            </Row>
            {/* <p className="text-muted mb-0">
              We craft digital, graphic and dimensional thinking.
            </p> */}
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

MonthlyEarning.propTypes = {
  date: PropTypes.object,
  data: PropTypes.object,
};

export default MonthlyEarning;
